// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"c3-z"};